import { Users, Search } from "lucide-react";
import { useState } from "react";

interface SalepageUsersProps {
  allUsers: any[];
  getStatusBadge: (status: string) => JSX.Element;
  onUserClick: (user: any) => void;
}

export default function SalepageUsers({ allUsers, getStatusBadge, onUserClick }: SalepageUsersProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = allUsers.filter(user => 
    user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.displayName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.username?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Users className="w-6 h-6 text-emerald-600" />
          ผู้ใช้งานทั้งหมด ({allUsers.length})
        </h2>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="ค้นหาผู้ใช้..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-semibold text-gray-700">ผู้ใช้</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">อีเมล</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Username</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">สถานะ</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">วันที่เริ่ม</th>
              <th className="text-right py-3 px-4 font-semibold text-gray-700">การกระทำ</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user, index) => (
                <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-semibold">
                        {user.email?.[0]?.toUpperCase() || 'U'}
                      </div>
                      <span className="font-medium text-gray-900">{user.displayName || 'ไม่ระบุ'}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-600">{user.email}</td>
                  <td className="py-3 px-4 text-gray-600">{user.username || '-'}</td>
                  <td className="py-3 px-4">
                    {getStatusBadge(user.salePageSubscription?.status || 'unknown')}
                  </td>
                  <td className="py-3 px-4 text-gray-600">
                    {user.salePageSubscription?.startDate?.toDate().toLocaleDateString('th-TH') || '-'}
                  </td>
                  <td className="py-3 px-4 text-right">
                    <button
                      onClick={() => onUserClick(user)}
                      className="text-emerald-600 hover:text-emerald-700 font-medium"
                    >
                      ดูรายละเอียด
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="py-12 text-center text-gray-500">
                  ไม่พบผู้ใช้
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
